enum IndiFormType {
  CASE = 'case',
  FOLLOWUP = 'followUp',
}

export default IndiFormType
